// extracted by mini-css-extract-plugin
module.exports = {"texts":"ManagePermisionsPageContent_texts__KQ2oW","permisionsBtn":"ManagePermisionsPageContent_permisionsBtn__SOQV6","ant-btn":"ManagePermisionsPageContent_ant-btn__MoNKc"};